import React, { useContext } from "react";
import { useFormik } from "formik";
import CustomButton from "../CustomButton";
import { Col, Row } from "react-bootstrap";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import { inviteMemberToOrganization } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import ModalUI from "../ui/ModalUI";
import ShortTextInput, { HelperError } from "../Inputs/ShortTextInput";
import DropdownInput from "../Inputs/DropdownInput";
import { memberRoleValidationSchema } from "../../utils/validations";

function AddMembersToOrganization({ show, handleClose, organization_id }) {
  const { refresh } = useContext(OrganizationContext);
  const formik = useFormik({
    initialValues: {
      email: "",
      role: "",
    },
    validationSchema: memberRoleValidationSchema,
    onSubmit: (values, { setSubmitting, setErrors }) => {
      const payload = {
        email: values.email,
        role: values.role,
      };

      // call the api to add member to the project
      inviteMemberToOrganization(organization_id, payload)
        .then((response) => {
          if (response.status === 200) {
            refresh();
            formik.resetForm();
            console.log("Organization updated successfully");
            showToast("Member invited successfully", "success");
          }
        })
        .finally(() => {
          setSubmitting(false);
          handleClose(); // Close modal on success
        });
    },
  });
  

  return (
    <AddMemberModalUI
      show={show}
      handleClose={handleClose}
      formik={formik}
      bodyText="Enter your colleagues email addresses below and we'll send them an invitation to this organization."
      roleOptions={[
        { id: "admin", name: "Admin" },
        { id: "biller", name: "Biller" },
        { id: "member", name: "Member" },
      ]}
      buttonText="Invite"
      title="Invite Members"
    />
  );
}

export default AddMembersToOrganization;


// this is the UI component that will be used in the AddMembersToOrganization component and add members to project component
export const AddMemberModalUI = ({
  show,
  handleClose,
  formik,
  bodyText="Enter your colleagues email addresses below and we'll send them an invitation to this organization.",
  roleOptions=[],
  buttonText="Invite",
  title="Invite Members",
}) => {
  return (
    <ModalUI show={show} handleClose={handleClose} title={title}>
      <div className="text-center">
        <div className="p4 text-secondary">
          {bodyText}
        </div>

        {/* Formik Form */}
        <form onSubmit={formik.handleSubmit} className="pt-4">
          <Row className="p-0 gap-2">
            <Col>
              <ShortTextInput
                containerClassName="mb-0"
                id="email"
                name="email"
                placeholder="example@email.com"
                value={formik.values.email}
                onChange={formik.handleChange}
              />
            </Col>
            <Col xs={3} className="p-0">
              <DropdownInput
                id="role"
                name="role"
                options={roleOptions}
                placeholder="Role"
                value={formik.values.role}
                onChange={formik.handleChange}
              />
            </Col>
          </Row>
          <HelperError 
            id="email-helper-text"
            error={(formik.touched.email && formik.errors.email) || formik.errors.role}
          />
          <div className="d-flex justify-content-center mt-4">
            <CustomButton type="submit" disabled={formik.isSubmitting}>
              {buttonText}
            </CustomButton>
          </div>
        </form>
      </div>
    </ModalUI>
  );
}